import { Component } from "@angular/core";
import { FooterInfoLinksComponent } from "@shared/components/molecules/footer-info-links/footer-info-links.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-auth-footer",
  imports: [FooterInfoLinksComponent, TranslatePipe],
  styleUrls: ["./auth-footer.component.scss"],
  templateUrl: "./auth-footer.component.html",
})
export class AuthFooterComponent {}
